import { Link } from 'gatsby'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

import CloseArrow from '../../../images/close.svg'

type Props = {
  onClose: () => void
}

const CateringDeliveryConfirmation: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <>
      <button className="modal__close" onClick={onClose}>
        <img src={CloseArrow} />
      </button>
      <div className="modal__title modal__title--small">{t('Sorry!')}</div>
      <div className="modal__subtitle">{t("We don't deliver to your address yet!")}</div>
      <div className="modal__content">
        <div>
          <button className="form__action form__action--full red-cta red-cta--reverse" onClick={onClose}>
            {t('Try another address')}
          </button>
          <Link to="/" className="form__action form__action--full red-cta">
            {t('Check out MealPal for pick up near you')}
          </Link>
        </div>
      </div>
    </>
  )
}

export default CateringDeliveryConfirmation
